import './App.css';
import { Route, Routes } from 'react-router-dom';
import Layout from './components/layout';
import About from './pages/about';
import Contact from './pages/contact';
import Portfolio from './pages/portfolio';
import Services from './pages/services';
import Testimonials from './pages/testimonials';
import Transform from './pages/transform';
import AllPages from './pages/allPages';

function App() {

  const sharedRoutes = [
    <Route index element={<AllPages />}  />,
    <Route path="/home" element={<AllPages />}  />,
    <Route path="/about" element={<About />}  />,
    <Route path="/transform" element={<Transform />}  />,
    <Route path="/portfolio" element={<Portfolio />}  />,
    <Route path="/services" element={<Services />}  />,
    <Route path="/testimonials" element={<Testimonials />} />,
    <Route path="/contact" element={<Contact />}  />
  ];

  return (
      <Routes>
        <Route path="/" element={<Layout />}>
          {sharedRoutes}
        </Route>
      </Routes>
  );
}

export default App;
